import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** Phone with a soft pulsing notification dot at the top. The `active`
 *  prop turns the pulse on / off (turn it off when the field is empty
 *  so the eye doesn't get drawn to a parked input). */
export function IcnPhone(props: AnimatedIconProps): ReactNode {
  const { active = true, ...rest } = props;
  const animate = useDecorativeIconMotion(active);
  return (
    <Svg {...rest} iconName="phone" data-on={active ? 'true' : 'false'}>
      <rect x="4.5" y="1.5" width="7" height="13" rx="1.6" />
      <path d="M7 12.5h2" />
      {/* Pulsing dot at the earpiece */}
      <circle cx="8" cy="3.6" r="0.55" fill="currentColor" stroke="none">
        {animate && (
          <>
            <animate
              attributeName="r"
              values="0.55;0.95;0.55"
              dur="2.2s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              values="1;0.4;1"
              dur="2.2s"
              repeatCount="indefinite"
            />
          </>
        )}
      </circle>
    </Svg>
  );
}
